import { createSelector } from 'reselect';

import { AMP_FILTER_OPTIONS } from './const';

/**
 * select amp state
 * @param {object} state - global state
 * @returns {object} amp state
 */
const ampSelector = state => state.amp || {};

export const filterSelector = createSelector(ampSelector, amp => amp.filter);

export const isFetchingSelector = createSelector(ampSelector, amp => amp.isFetching);

export const payloadSelector = createSelector(ampSelector, ({ filter, payload }) =>
  filter === AMP_FILTER_OPTIONS[0]
    ? payload
    : payload.filter(({ editorialImageType }) => editorialImageType === filter)
);
